import { useEffect, useRef, useState } from 'react';
import './QrStyles.css';
import QrScanner from 'qr-scanner';

const NoCamIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    className='size-6'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 0 1-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 0 0-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409'
    />
  </svg>
);

// Called when a QR code is successfully scanned
const onScanSuccessDefault = (result) => {
  console.log('QrReader Result', result);
};

// Called when scanning fails
const onScanFailDefault = (err) => {
  if (err === 'No QR code found') return;

  console.warn('QrReader Error', err);
};

const QrReader = ({
  onScanSuccess = onScanSuccessDefault,
  onScanFail = onScanFailDefault,
}) => {
  // Refs for scanner, video element, and scan box overlay
  const scanner = useRef(null);
  const videoEl = useRef(null);
  const qrBoxEl = useRef(null);

  // State to track if scanner is active
  const [qrOn, setQrOn] = useState(true);

  useEffect(() => {
    if (videoEl?.current && !scanner.current) {
      // Initialize the scanner
      scanner.current = new QrScanner(videoEl.current, onScanSuccess, {
        onDecodeError: onScanFail,
        preferredCamera: 'environment', // Use back camera on mobile (valeur par défaut
        highlightScanRegion: true, // Show scan box
        highlightCodeOutline: true, // Highlight detected codes
        overlay: qrBoxEl.current || undefined, // Custom overlay box
      });

      // Start the scanner
      scanner.current
        .start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }

    // Stop scanner on unmount
    return () => {
      if (!videoEl?.current) {
        scanner.current?.stop();
      }
    };
  }, [onScanSuccess, onScanFail]);

  // Alert if scanner fails to start (e.g. camera permission blocked)
  useEffect(() => {
    if (!qrOn) {
      alert(
        'Camera is blocked or not accessible. Please allow camera access in your browser settings and reload the page.',
      );
    }
  }, [qrOn]);

  return (
    <div className='qr-reader'>
      {/* Video stream for scanning */}
      <video ref={videoEl}></video>

      {/* Scan box overlay */}
      <div
        ref={qrBoxEl}
        className='qr-box'
      >
        {!videoEl?.current && (
          <div className='qr-frame'>
            <NoCamIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default QrReader;
